import React from "react"
import "./leftSectionTitle.css"

export default props => (
  <React.Fragment>
    <h1 className="section-title">{props.title}</h1>
    <h5 className="section-subtitle">{props.subTitle}</h5>
  </React.Fragment>
)
